import { call, take, put } from 'redux-saga/effects';
import axios               from 'axios';
import { SET_USER_VIDEOS } from 'actions/contentActions';



const endpoint = 'https://www.yisumatica.org.il/yisumaticaApi/deleteUserVideo.php';

function* deleteUserVideo(): Generator<any,any,any> {
  while(true) {
    try {

        const userInput = yield take('DELETE_USER_VIDEO_SAGA');
        const { videoId, newUserVideos } = userInput.payload;
        
        if (process.env.NODE_ENV === 'development') {

          console.log('videoId     : ',videoId)
          yield put(SET_USER_VIDEOS( newUserVideos ))

        }
        if (process.env.NODE_ENV === 'production') {
      
            const res = yield call( axios.post, endpoint, { videoId });

            if (res.data && res.data.success && res.data.success === 1 ) {
               console.log('success')
               yield put(SET_USER_VIDEOS( newUserVideos ))

            }
            else {
              console.log("can't delete video")
            }  
        }
    }
    catch(err) {
      console.log('err  :  '+err);
    }
    finally {}
  }
}


export default deleteUserVideo;






